export const TYPE_USER_ATTRIBUTE = 'user_attribute';
//# sourceMappingURL=user_attribute_type.js.map